import React, { useCallback } from 'react';
import BaseActionListItem from './index';
import FileTrigger from './file-trigger';
// @ts-ignore TS(2322): Type 'Function' is not assignable to type '(...arg... Remove this comment to see the full error message
const ActionListFileTrigger = ({
  fileTriggerConfig,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'IconGlyph'.
  iconGlyph = null,
  disabled = false,
  selected = false,
  onClick = Function.prototype,
  ...otherProps
}) => {
  const File = useCallback(
    ({ children }) => (
      <React.Fragment>
        {children}
        <FileTrigger {...fileTriggerConfig} />
      </React.Fragment>
    ),
    [fileTriggerConfig]
  );

  return (
    <BaseActionListItem
      iconGlyph={iconGlyph}
      disabled={disabled}
      selected={selected}
      onClick={onClick}
      component={File}
      {...otherProps}
    />
  );
};

export default ActionListFileTrigger;
